var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{class:[
    'text-xs font-semibold px-3 py-2 rounded-t group',
    {
      'text-deep-cerulean': _vm.hasDescription,
      'text-abbey': !_vm.hasDescription,
      'border-b border-alto': _vm.open && !_vm.hasDescription,
      'border-b border-deep-cerulean-less-transparent': _vm.open && _vm.hasDescription
    }
  ],on:{"click":_vm.onToggle}},[_c('div',{staticClass:"flex flex-col"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"flex flex-1 justify-end items-center"},[(_vm.hasDescription)?_c('BaseButton',{staticClass:"flex",on:{"click":function($event){return _vm.onClear($event)}}},[_c('BaseIcon',{staticClass:"text-deep-cerulean-less-transparent hover:text-deep-cerulean",attrs:{"name":"times-circle","height":"14","width":"14"}})],1):_vm._e(),_c('BaseIcon',{class:[
            'ml-4',
            {
              'text-silver-sand group-hover:text-abbey': !_vm.hasDescription,
              'text-deep-cerulean-less-transparent group-hover:text-deep-cerulean': _vm.hasDescription
            }
          ],attrs:{"name":_vm.open ? 'chevron-up' : 'chevron-down',"height":"10","width":"10"}})],1)]),(_vm.hasDescription)?_c('div',{staticClass:"flex applied-filters-container font-normal"},[_c('span',[_vm._v(_vm._s(_vm.description))])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }